import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'

const Login = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState<string | null>(null)
    const [success, setSuccess] = useState(false)

    const handleSubmit = async () => {
        setError(null)
        const res = await fetch('/ff/api/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
        })
        const data = await res.json()
        if (data.success) {
            setSuccess(true)
        } else {
            setError(data.error || 'Login failed')
        }
    }

    return (
        <Box>
            <Typography variant="h4">Login</Typography>
            <TableContainer component={Paper} sx={{ mt: 1, mb: 2, maxWidth: 480 }}>
                <Table aria-label="login form">
                    <TableBody>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell component="th" scope="row">Email</TableCell>
                            <TableCell>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell component="th" scope="row">Password</TableCell>
                            <TableCell>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type="password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                />
                            </TableCell>
                        </TableRow>
                        {error && (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell colSpan={2}>
                                    <Typography color="error">{error}</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {success && (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell colSpan={2}>
                                    <Typography color="success.main">Logged in successfully!</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell colSpan={2}>
                                <Button variant="contained" onClick={handleSubmit}>Login</Button>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default Login
